import { Col, Row } from 'reactstrap';

interface Props {
  maisEconomica: boolean;
  maisEficiente: boolean;
  opcaoManual: boolean | false;
}

function SinalizaEficienciaCusto({
  maisEconomica,
  maisEficiente,
  opcaoManual,
}: Props): JSX.Element {
  function renderBadgeMenorCusto() {
    return (
      <div className="badge badge-success badge-lg">
        <i className="ni ni-money-coins" /> Mais econômico
      </div>
    );
  }

  function renderBadgeMelhorEficiencia() {
    return (
      <div className="badge badge-warning badge-lg">
        <i className="ni ni-chart-bar-32" /> Mais eficiente
      </div>
    );
  }

  function renderBadgeOpcaoManual() {
    return (
      <div className="badge badge-default badge-lg">
        <i className="ni ni-chart-bar-32" /> Manual
      </div>
    );
  }

  return (
    <Row>
      {maisEconomica && <Col>{renderBadgeMenorCusto()}</Col>}
      {maisEficiente && <Col>{renderBadgeMelhorEficiencia()}</Col>}
      {opcaoManual && <Col>{renderBadgeOpcaoManual()}</Col>}
    </Row>
  );
}

export default SinalizaEficienciaCusto;
